// extracted by mini-css-extract-plugin
module.exports = {"userTypeWarning":"admin-portal__AppContent__userTypeWarning","logoutButton":"admin-portal__AppContent__logoutButton"};